exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-yellow {\n  color: #ffb500;\n}\n", ""]);

// exports
